if (typeof Array.prototype.flat === 'undefined') {
    Array.prototype.flat = function(depth = 1) {
    return this.reduce((flat, toFlatten) => {
      return flat.concat(
      Array.isArray(toFlatten) && depth > 1
        ? toFlatten.flat(depth - 1)
        : toFlatten
      );
    }, []);
    };
  }
  if (typeof window.globalThis === 'undefined') {
    window.globalThis = window;
  }
 
  if (typeof window.queueMicrotask === 'undefined') {
    window.queueMicrotask = function(callback) {
      Promise.resolve().then(callback);
    };
  }

  if (typeof Object.fromEntries === 'undefined') {
    Object.fromEntries = function fromEntries(iterable) {
      return [...iterable].reduce((obj, [key, val]) => {
        obj[key] = val;
        return obj;
      }, {});
    };
  }